import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import todoApp from './todo/reducer';
import chatApp from './chat/reducer';
import surveyListApp from './surveyList/reducer';
import surveyDetailApp from './surveyDetail/reducer';
import userManagementApp from './user/reducer';
import companyDetailApp from './company/reducer';
import yachtInfoApp from './yachtInfo/reducer';
import promotionApp from './promotion/reducer';
import bookingApp from './booking/reducer';
// import AddressOptionApp from './address/reducer';

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  todoApp,
  chatApp,
  surveyListApp,
  surveyDetailApp,
  userManagementApp,
  companyDetailApp,
  yachtInfoApp,
  promotionApp,
  bookingApp
  // AddressOptionApp,
});

export default reducers;
